// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__EjpFy","hidden":"Switch_hidden__+s5sZ","compact":"Switch_compact__d5zlu","labelText":"Switch_labelText__yVT3s"};